import { render } from "./westStoredModel.vue?vue&type=template&id=494716d0"
import script from "./westStoredModel.vue?vue&type=script&lang=js"
export * from "./westStoredModel.vue?vue&type=script&lang=js"

import "./westStoredModel.vue?vue&type=style&index=0&id=494716d0&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__